import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import { useLanguage } from "@/i18n/LanguageContext";

const TEST_IDS = ["about-chinese-culture-card", "about-killing-zeros-card", "about-red-bull-card", "about-why-bsc-card", "about-community-card"];

// Numbered manifesto chapters
export default function About() {
  const { t } = useLanguage();
  const chapters = t("about.chapters");
  return (
    <section id="about" className="scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8" data-testid="about-section">
      <div className="mx-auto max-w-7xl">
        <SectionHeader kicker={t("about.kicker")} title={t("about.title")} id="about" />
        <div className="space-y-0">
          {chapters.map((c, i) => (
            <Reveal key={c.t} delay={0.05 * i}>
              <article
                data-testid={TEST_IDS[i]}
                className="group grid gap-4 border-t border-red-900/20 py-10 sm:grid-cols-12 sm:gap-8 sm:py-14"
              >
                <div className="sm:col-span-3">
                  <span className="font-display text-5xl font-black text-red-950 transition-colors duration-500 group-hover:text-red-800 sm:text-7xl" aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="sm:col-span-9">
                  <h3 className="mb-3 text-xl font-bold tracking-tight text-zinc-100 sm:text-2xl">{c.t}</h3>
                  <p className="max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">{c.d}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
